// extracted by mini-css-extract-plugin
export var section = "Benefits-module--section--x41HR";
export var container = "Benefits-module--container--vLWgs";
export var imageBg = "Benefits-module--imageBg--+fqcM";
export var mobileImageBg = "Benefits-module--mobileImageBg--GQ5o9";
export var title = "Benefits-module--title--HUmww";